import { IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from '@material-ui/core';
import {VisibilityOff, Visibility, Group as GroupIcon} from '@material-ui/icons';
import React, { useState } from 'react';
import { cubeRepository } from '../../../Domain/Repositories/CubeRepository';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import Loading from "../../UiComponents/Loading";
import {TrafficShapingStatus} from "../../../Domain/Models/TrafficShapingStatus";
import Cube from "../../../Domain/Models/Cube";
import Group from "../../../Domain/Models/Group";
import DecisionModal from "../../UiComponents/DecisionModal";
import {QueueLineService} from "../../../Domain/Services/QueueLineService";
import QueueListRow from "./QueueListRow";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));

export interface QueueListProps
{
  trafficShapingStatus?: TrafficShapingStatus;
  errorCardController: React.RefObject<ErrorCardController>;
  forceUpdate: () => void;
}

export default function QueueList(props: QueueListProps)
{
  const classes = useStyles();
  const { trafficShapingStatus, errorCardController, forceUpdate } = props;

  const [idVisible, setIdVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [queueLineDialogOpen, setQueueLineDialogOpen] = useState(false);
  const [queueLineCube, setQueueLineCube] = useState<Cube>();
  const [queueLineGroup, setQueueLineGroup] = useState<Group>();
  
  const handleAdmitToQueueLineClicked = (cube: Cube, group: Group) =>
  {
    setQueueLineCube(cube);
    setQueueLineGroup(group);
    setQueueLineDialogOpen(true);
  }
  
  const handleAdmitQueueLineAccepted = (cube: Cube, group: Group) =>
  {    
    QueueLineService.checkIn(cube, group)
      .then(() => forceUpdate())
      .catch((e: Error) =>
      {
        errorCardController.current?.addErrorMessage(e.message)
      });

    handleDialogClose();
  }
  
  const handleDialogClose = () =>
  {
    setQueueLineCube(undefined);
    setQueueLineGroup(undefined);
    setQueueLineDialogOpen(false);
  }

  return (
      <>
      {queueLineGroup && queueLineCube && (
        <DecisionModal
          open={queueLineDialogOpen}
          message={`Check ${queueLineGroup.playerPairs.map(x => x.name).join(' vs. ')} into ${queueLineCube.name} queue line?`}
          onAccept={() => handleAdmitQueueLineAccepted(queueLineCube, queueLineGroup)}
          onCancel={handleDialogClose}
          />
      )}
        
        <Paper className={classes.paper}>
          <Toolbar>
            <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
              Cubes
            </Typography>
            <IconButton size="small" color="default" onClick={() => setIdVisible(!idVisible)}>
              {idVisible ? <VisibilityOff/> : <Visibility/>}
            </IconButton>
          </Toolbar>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell />
                  {idVisible && <TableCell>ID</TableCell>}
                  <TableCell>Group Name</TableCell>
                  <TableCell>Queue Entry Time</TableCell>
                  <TableCell>Earliest Match Time</TableCell>
                  <TableCell>Matched Time</TableCell>
                  <TableCell>Matched Cube</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {trafficShapingStatus?.cubeMatchingEntries?.map((row) => (
                  <QueueListRow key={row.id} idVisible={idVisible} cubeMatchingEntry={row} handleAdmitToQueueLineClicked={handleAdmitToQueueLineClicked} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>
      </>
  );
}